import useI18n from '../hooks/useI18n';
import { UserContext } from '@/context/UserContext';
import { useContext } from 'react';
import BrandDetailComponent from '@/components/common/campaign/BrandDetailComponent';
import CashbackSettingsComponent from '@/components/common/campaign/CashbackSettingsComponent';
import SelectAreaComponent from '@/components/common/campaign/SelectAreaComponent';
import CreativeBriefComponent from '@/components/common/campaign/CreativeBriefComponent';
import ChooseContentComponent from '@/components/common/campaign/ChooseContentComponent';
import { FormDataForCreateCampaign } from '@/types/interfaces';
import { Button } from '@/components/common/Button';

interface CreateCampaignFinalStepProps {
  isEditCampaign: boolean;
  formData: FormDataForCreateCampaign;
  onNext: (values: FormDataForCreateCampaign) => void;
  onPrevious: () => void;
  isLoading?: boolean;
}

const PreviewCampaign: React.FC<CreateCampaignFinalStepProps> = ({
  isEditCampaign,
  formData,
  onNext,
  onPrevious,
  isLoading,
}) => {
  const { t } = useI18n();
  const userContext = useContext(UserContext);

  if (!userContext) {
    throw new Error('useContext must be used within a UserProvider');
  }
  const { user } = userContext;

  return (
    <div className="bg-white flex flex-col flex-1 min-h-0">
      <div className="flex justify-between items-center shrink-0">
        <Button onClick={onPrevious} variant="" className="!p-0">
          <div className="flex gap-3">
            <img
              src="../assets/leftArrow.svg"
              alt={String(t('campaign.navigation.backArrow'))}
            />
            <span className="text-[#113E53] text-sm">{t('common.back')}</span>
          </div>
        </Button>
        <div className={` flex  gap-4 justify-end `}>
          <Button
            onClick={() => onNext(formData)}
            className="mt-6"
            disabled={isLoading}
          >
            {isEditCampaign
              ? t('common.updateCampaign')
              : t('common.launchCampaign')}
          </Button>
        </div>
      </div>
      <div className="flex gap-4 items-center mb-4 shrink-0">
        <img
          src={
            user?.brand?.brandLogo
              ? user.brand.brandLogo
              : '/assets/Brand default dp.svg'
          }
          className="border-2 border-[#E5E9EB] h-[65px] w-[65px] rounded-full object-cover"
        />
        <div>
          <div className="text-[#121111] font-medium text-lg">
            {user?.brand?.name}
          </div>
          <div className="text-[#B3B3B2] text-base font-normal">
            {t('common.pleaseReviewAllCampaignDetailsCarefullyBeforeLaunching')}
          </div>
        </div>
      </div>
      <div
        className="flex-1 min-h-0 overflow-y-auto"
        style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        <BrandDetailComponent formData={formData} />
        <div className="border border-[#B3B3B2] mb-[24px]" />
        <CashbackSettingsComponent formData={formData} />
        <div className="border border-[#B3B3B2] mb-[24px]" />
        <ChooseContentComponent formData={formData} />
        <div className="border border-[#B3B3B2] mb-[24px]" />
        <SelectAreaComponent formData={formData} />
        <div className="border border-[#B3B3B2] mb-[24px]" />
        <CreativeBriefComponent formData={formData} />
      </div>
    </div>
  );
};

export default PreviewCampaign;
